import { render } from "./HelloWorld.vue?vue&type=template&id=53531a83&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=53531a83&scoped=true&lang=scss"

import exportComponent from "E:\\work\\project_4\\核验\\heyan\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53531a83"]])

export default __exports__